var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWrenchColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32.3454896px",
    height: "32.3454896px",
    viewBox: "0 0 32.3454896 32.3454896",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_wrench_color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gestionnaire---Param\\xE8tres",
    transform: "translate(-815.856711, -322.856711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_wrench_color",
    transform: "translate(812.000000, 319.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6666667,16.6666667 L16.6666667,16.6666667 L16.6666667,11.6666667 L10.8333333,5.83333333 C14.6574194,4.00697947 19.2174469,4.78935651 22.2140452,7.78595479 C25.2106435,10.7825531 25.9930205,15.3425806 24.1666667,19.1666667 L34.1666667,29.1666667 C35.5473785,30.5473785 35.5473785,32.7859548 34.1666667,34.1666667 C32.7859548,35.5473785 30.5473785,35.5473785 29.1666667,34.1666667 L19.1666667,24.1666667 C15.3425806,25.9930205 10.7825531,25.2106435 7.78595479,22.2140452 C4.78935651,19.2174469 4.00697947,14.6574194 5.83333333,10.8333333 L11.6666667,16.6666667",
    id: "Path",
    stroke: "#AFBC9D",
    strokeWidth: 2,
    fill: "#AFBC9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWrenchColor);
export default __webpack_public_path__ + "static/media/icon_wrench_color.6d666cdbe22325275a1620632d4fe3d8.svg";
export { ForwardRef as ReactComponent };